import { memo } from 'react';

import { useAuthTokensRefreshManagement } from './hooks/useAuthTokensRefreshManagement';
import { AuthTokensRefreshProps } from './types/AuthTokensRefreshProps';
import { AuthTokensRefreshDataContext } from './AuthTokensRefreshDataContext';

const AuthTokensRefreshProviderComponent = ({
  children,
}: AuthTokensRefreshProps) => {
  const { dataValue } = useAuthTokensRefreshManagement();

  return (
    <AuthTokensRefreshDataContext.Provider value={dataValue}>
      {children}
    </AuthTokensRefreshDataContext.Provider>
  );
};

export const AuthTokensRefreshProvider = memo(
  AuthTokensRefreshProviderComponent,
);
